import React, { useEffect, useState, useContext,useRef } from 'react';
import { Button } from 'primereact/button';
import { Calendar } from 'primereact/calendar';
import {timesheetreportService} from '../services/timesheetreportsService';
import {timesheetService} from '../services/timesheetService';
import {timesheetuserService} from '../services/timesheetUserservice';
import {formatterhelper} from '../helpers/dateformatter';
import {loader} from '../compnents/loadermd';
import {dataExporthelper} from '../helpers/exporthelper';
import { Toast } from 'primereact/toast';
import { domainUrl } from '../constant';
import { FaTrash,FaEdit } from 'react-icons/fa';
import { FcUpload } from "react-icons/fc";
import { FcSalesPerformance } from "react-icons/fc";


import {Mandate} from '../compnents/formcomp';
import { Dialog } from 'primereact/dialog';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import 'react-tabs/style/react-tabs.css';

const Targethourstemplates = () => {
    const toast = useRef(null);
    const [formData,setFormData] = useState({"targetdate":"","user_id":"","target_hours":"","adjustmentvalue":"","adjustmentdate":""});
    const [formData2,setFormData2] = useState({"fromdate2":"","todate2":"","user_id2":"","target_hours2":""});
    const [formData3,setFormData3] = useState({"fromdate":"","todate":"","client_id":"","target_hours":"","type":""});
    // const [formData, setFormData] = useState({
    //     fromdate: '',
    //     todate: '',
    //     manager: '',
    //     managername: '',
    //     employee: 'ALL',
        
    //   });
    const [popupvisible,setVisibility] = useState(false);
    const [popupvisibleClient,setVisibilityClient] = useState(false);
    const [loadercomp,setloadecomp] = useState(null);  
    const [datacomp,setDatacomp] = useState([]); 
    const [manager,setmanger] = useState([]); 
    const [dataavail,setDatastate] = useState(false); 
    const [isloaded,setloaded] = useState(true); 
    const [managerscomp,setmanagercomp] = useState([]); 
    const [subclientscomp,setsubClientscomp] = useState([]); 
    const [empcomp,setempcomp] = useState([]); 
    const userdata = localStorage.getItem('user') != '' ? JSON.parse(localStorage.getItem('user')) : {};
    const [currentuser,setUser] = useState(''); 
    const [break_time,setBreaktime] = useState('');
    const [rdsdata,setRdsData] = useState({'currentuser':'','break_time':''});
    const [errors, setErrors] = useState({});
    const [userscomp, setUserscomp] = useState([]);
    const [fileselected, setexcelFile] = useState('');
    const [targethousrsdata, settargethoursdata] = useState([]);
    const [usertargethousrsdatatemp, setusertargethoursdatatemp] = useState([]);
    const [istargethousrsloaded, settargethoursloaded] = useState(true);
    const [adjustmentvalues,setadjustmentvalues] = useState({});
    const [adjustmentclientvalues,setadjustmentclientvalues] = useState({"client":"","targethours":""});
    
    const [targettemp,settargettemp] = useState({});
    const [adjustmentdata, setAdjustmentdata] = useState([]);
    const [clienttarget, setClienttarget] = useState([]);
    const [clienttargettemp, setClienttargettemp] = useState([]);
    const [cleintscomp,setClientscomp] = useState([]);
    const [popupvisibleadjustment,setpopupvisibleadjustment] = useState(false); 
    const [adjustmentdatanewvalue,setadjustmentdatanewvalue] = useState({}); 
    const [selecteduser,setuserid] = useState(''); 

    const [clientallocation,setclientallocation] = useState([]); 
    const [clientallocationtemp,setclientallocationTemp] = useState([]); 
    const [clientallocationindex,setclientallocationindex] = useState(0); 
    const [isqaloaded,setqaloaded] = useState(true);
    const [isupdated,setUpdation] = useState(true);
    const [cronstatus,setcronstatus] = useState(false);
    const [crondaterange,setcrondaterange] = useState({firstDate: 0, lastDate: 0});
    const [isclientupdated,setisclientupdated] = useState(true);

    useEffect(()=>{
        _getemplist({managerid:userdata.id});
        get_user_details({managerid:userdata.id});
        qaallocationdisplay();
        // _getclientslist();
        // console.log("user data");
        // console.log(userdata.id);
        getmanagerlist();
        getmultitargethours();
        getmultitargethoursadjustment();
        _getclientslist();
        getmulticlienttargethours();
       
        // gettargetadjustment();
        
    },[]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevData) => ({
          ...prevData,
          [name]: value,
        }));
    };


    function gettargetadjustment(values){
        setuserid(values.userid);
                timesheetService.gettargetadjustment(values.userid,values.from_date,values.to_date).then((response)=>{
             if(response.status == 200){
                setAdjustmentdata(response.data.data);
             }else{
                setAdjustmentdata([]);  
             }
        }).catch((error)=>{
            setAdjustmentdata([]); 
            console.log(error); 
        }); 
    }

    function editadjustmentvalue(value){
        setpopupvisibleadjustment(true);
        setadjustmentdatanewvalue(value);
    }

   
    function displayadjustmentversion2(){
        
        let empcomp = [];
        // console.log('adjustment value');
        // console.log(adjustmentdata);
        // return;
         
        adjustmentdata.forEach((element,index) => {
            empcomp.push(<tr>
                <td>{element.id}</td>
                <td><input type='text' disabled value={element.adjustmentval}/></td>
                <td>{element.adjustmentdate}</td>
                <td>{element.created_at}</td>
                <td>{element.updated_at}</td>
                
                <td><button type='button' className='btn btn-success' onClick={() => editadjustmentvalue(element)}>
                       <FaEdit/>
                    </button> 
                    &nbsp;
                    <button type='button' className='btn btn-danger' onClick={() => delete_target_adjustment_tbl(element.id)}>
                      <FaTrash/>
                    </button>
                </td>
                
            </tr>);   
         });
         return (<>
             <table id="userdetails-table"  className="table table-bordered">
                <thead>
                    <tr>
                    <th>ID</th>
                    <th>Adjust target</th>
                    <th>Adjust Date</th>
                    <th>Created at</th>
                    <th>Updated at</th>
                    <th>Action</th>
                    </tr>
                </thead>
               <tbody> 
                {empcomp}
              </tbody>
             </table>
            </>); 
    }
    

    const validateForm = () => {
        let valid = true;
        const newErrors = {};
  
        if (formData.user_id == '') {
          newErrors.user_id = 'Userid is required';
          valid = false;
        }

        if (formData.target_hours == '') {
            newErrors.target_hours = 'Target_hours is required';
            valid = false;
        }

        if (formData.targetdate == '') {
            newErrors.targetdate = 'Targetdate is required';
           valid = false;
        }  
       setErrors(newErrors);
       return valid; 
    }  

    const handleSubmit = (e) => {
        e.preventDefault();
        if(!validateForm()){
            return;
        }
        // console.log(formData); 
        let rdsobj = {"targetdate":formatterhelper.dateformatter({date:formData.targetdate}),"user_id":formData.user_id,"target_hours":formData.target_hours};  
        // console.log(rdsobj);
        timesheetuserService.addtaget_hours({formobj:rdsobj}).then((response)=>{
            // console.log(response);  
            if(response.status == 200){
                toast.current.show({ severity: 'success', summary: 'Target hours', detail: 'Updated successfully', life: 3000 }); 
                setFormData({"targetdate":"","user_id":"","target_hours":""}); 
            }else{
                toast.current.show({ severity: 'error', summary: 'Target hours', detail: 'Not updated', life: 3000 });   
            }  
        }).catch((error)=>{
            console.log(error);
            toast.current.show({ severity: 'error', summary: 'Target hours', detail: 'Something went wrong', life: 3000 });  
        });
       //console.log(rdsobj);
       // getrdsreports(rdsobj)
       // getreports(reportobj);
      };
   
    const handleChange2 = (e) => {
        const { name, value } = e.target;
        setFormData2((prevData) => ({
            ...prevData,
            [name]: value,
        }));
    };
    
    const handleChange3 = (e) => {
        const { name, value } = e.target;
        setFormData3((prevData) => ({
            ...prevData,
            [name]: value,
        }));
    };

    function getmulticlienttargethours(){
       timesheetService.getmulticlienttargethours().then((response)=>{
          console.log("response client target");  
          console.log(response);
          if(response.status == 200){
               console.log(response.data.data);
               setClienttarget(response.data.data);
               setClienttargettemp(response.data.data);
            //    const [clienttargettemp, setClienttargettemp] = useState([]);

          }else{
            setClienttarget([]);
          } 
       }).catch((error)=>{
        setClienttarget([]);
          console.log(error);
       });
    }

    function handleclientchangeddata(e){
        const { name, value } = e.target;
        setadjustmentclientvalues((prevData)=>({
           ...prevData,
           [name]:value
        }));   
    }
     

    function handleClientSubmitform(e){
        e.preventDefault();
        // console.log(adjustmentclientvalues);
        timesheetService.multiclienttargethoursupdate(adjustmentclientvalues).then((response)=>{
             if(response.status == 200){
                toast.current.show({ severity: 'success', summary: 'Client Target hours', detail: 'updated successfully', life: 3000 });  
                getmulticlienttargethours(); 
                setVisibilityClient(false);
              }else{
                toast.current.show({ severity: 'error', summary: 'Client Target hours', detail: response.data.data, life: 3000 });  
             }
               
        }).catch((error)=>{
            toast.current.show({ severity: 'error', summary: 'Target hours', detail: 'Error', life: 3000 });  
        });  
    }

    function editclienttarget(values){
           console.log(values);  
        // adjustmentclientvalues
        setadjustmentclientvalues(values);
        setVisibilityClient(true);
    }

    function deleteClienttarget(id){
          let obj = {
            'id':id
          };
          timesheetService.deleteClienttarget(obj).then((reeponse)=>{
             if(reeponse.status == 200){
                toast.current.show({ severity: 'success', summary: 'Client Target hours', detail: 'Deleted successfully', life: 3000 });
                getmulticlienttargethours(); 
             }else{
                toast.current.show({ severity: 'error', summary: 'Client Target hours', detail: 'Not deleted', life: 3000 });   
             }
          }).catch((error)=>{
            toast.current.show({ severity: 'error', summary: 'Client Target hours', detail: 'Error', life: 3000 }); 
          });
    }

    function displayclienttarget(){
         let empcomp = [];
         
         clienttarget.forEach(element => {
            empcomp.push(<tr>
                <td>{element.id}</td>
                <td>{element.client}</td>
                <td>{element.targethours}</td>
                <td>{element.from_date}</td>
                <td>{element.to_date}</td>
                <td>{element.manager_name}</td>
                <td>{element.type}</td>
                <td>{element.created_at}</td>
                <td>{element.updated_at}</td>
                
                <td><button className='btn btn-success' onClick={() => editclienttarget(element)}>
                       <FaEdit/>
                    </button> 
                    &nbsp;
                    <button className='btn btn-danger' onClick={() => deleteClienttarget(element.id)}>
                      <FaTrash/>
                    </button>
                </td>
                
            </tr>);   
         });
         return (<>
             <table id="userdetails-table"  className="table table-bordered">
                <thead>
                    <tr>
                    <th>ID</th>
                    <th>Client</th>
                    <th>Target Hours</th>
                    <th>From date</th>
                    <th>To date</th>
                    <th>Allocated Manager</th>
                    <th>Type</th>
                    <th>Created at</th>
                    <th>Updated at</th>
                    <th>Action</th>
                    </tr>
                </thead>
               <tbody> 
                {empcomp}
              </tbody>
             </table>
            </>);    
         
    }

    function handleSubmit3(e){
        e.preventDefault();
        let obj = {
            'targethours':formData3.target_hours,
            'fromdate':formatterhelper.dateformatter({date:formData3.fromdate}),
            'todate':formatterhelper.dateformatter({date:formData3.todate}),
            'client_id': formData3.client_id,
            'type': formData3.type
        }
        // console.log(obj);
        timesheetService.multiclienttargethoursinsert(obj).then((response)=>{
             if(response.status == 200){
                toast.current.show({ severity: 'success', summary: 'Client Multi Target hours', detail: 'Updated successfully', life: 3000 });  
                getmulticlienttargethours(); 
            }else{
                toast.current.show({ severity: 'error', summary: 'Client Multi Target hours', detail: response.data.data, life: 3000 });   
             }
        }).catch((error)=>{
            toast.current.show({ severity: 'error', summary: 'Client Multi Target hours', detail: 'Error', life: 3000 });   
        });
    } 

    function handleSubmit2(e){
        e.preventDefault();
        console.log("handle submit"); 
        // console.log(formData2);
        let obj = {
            'targethours':formData2.target_hours2,
            'fromdate':formatterhelper.dateformatter({date:formData2.fromdate2}),
            'todate':formatterhelper.dateformatter({date:formData2.todate2}),
            'user_id': formData2.user_id2
        }

        // console.log(obj);
        timesheetService.multitargethoursupdate(obj).then((response)=>{
             if(response.status == 200){
                toast.current.show({ severity: 'success', summary: 'Multi Target hours', detail: 'Updated successfully', life: 3000 });  
                getmultitargethours();
            }else{
                // console.log("response");
                // console.log(response.data.data);
                toast.current.show({ severity: 'error', summary: 'Multi Target hours', detail: response.data.data, life: 3000 });   
             }
        }).catch((error)=>{
            toast.current.show({ severity: 'error', summary: 'Multi Target hours', detail: 'Error', life: 3000 });   
        });
    }  

    function getmultitargethours(){
        console.log("get multi target hours");
        settargethoursloaded(false);
        timesheetService.getmultitargethours().then((response)=>{
           if(response.status == 200){
              settargethoursdata(response.data.data); 
              setusertargethoursdatatemp(response.data.data);
              settargethoursloaded(true);  
           }else{
              settargethoursdata([]);
              setusertargethoursdatatemp([]);
              settargethoursloaded(true);
           }
        }).catch((error)=>{
            settargethoursdata([]);
            setusertargethoursdatatemp([]);
            settargethoursloaded(true);
        }); 
    }

    function deletetarget(id){
       timesheetuserService.deletetarget(id).then((response)=>{
            if(response.status == 200){
                toast.current.show({ severity: 'success', summary: 'Target hours', detail: 'Deleted successfully', life: 3000 }); 
                getmultitargethours();
            }else{
                toast.current.show({ severity: 'error', summary: 'Target hours', detail: 'Not Deleted', life: 3000 }); 
            } 
       }).catch((error)=>{
           toast.current.show({ severity: 'error', summary: 'Target hours', detail: 'Error', life: 3000 });
       });
    }

    function editmultitarget(values){
    //    console.log("dsdsdsdsdsdsdsd");  
    //    console.log(values);
       setadjustmentvalues(values); 
       gettargetadjustment(values);
       setVisibility(true);
    }

    function displaytargethours(){
        let temarr = [];
        targethousrsdata.forEach((values,index)=>{
            temarr.push((<tr>
                  <td>{index + 1}</td>
                  <td>{values.name}</td>
                  <td>{values.targethours}</td>
                  <td>{values.from_date}</td>
                  <td>{values.to_date}</td>
                  <td>{values.created_at}</td>
                   <td>{values.updated_at}</td>
                  {/* <td>{values.adjustvalue}</td>
                  <td>{values.adjustdate}</td> */}
                  <td><button className='btn btn-success' onClick={() => editmultitarget(values)}>
                       <FaEdit/>
                    </button> 
                    &nbsp;
                    <button className='btn btn-danger' onClick={() => deletetarget(values.id)}>
                      <FaTrash/>
                    </button></td>
            </tr>)); 
        }); 
        
        return temarr;
    }

    
    function getmanagerlist(){
        let emparr = [];
        timesheetreportService.getmangrlist().then((response)=>{
           console.log('get manager list');
           console.log(response);
           response.data.data.forEach((value,index) =>{
              emparr.push((<option value={value.id}>{value.name}</option>));
           });
           setmanagercomp(emparr);
        }).catch((error)=>{

        });  
    }

    function _getemplist({managerid}){
        // let managerid = 1;
        let emparr = [];
        timesheetreportService.getemployeelist({managerid:managerid}).then((response)=>{
            console.log(response);
            response.data.data.forEach((value,index) =>{
                emparr.push((<option value={value.id}>{value.name}</option>));
            });
            setempcomp(emparr);
         }).catch((error)=>{
 
         });    
    }

    function get_user_details({managerid}){
        timesheetreportService.get_user_details({manager_id:managerid}).then((response)=>{
            console.log("response"); 
            console.log(response);
            if(response.status == 200){
                let comp = [];
                response.data.data.forEach((values)=>{
                      comp.push(<tr>
                        <td>{values.id}</td> 
                        <td>{values.userid}</td>
                    </tr>);
                });
                
                setUserscomp(comp);
            }else{
                  
            }
        }).catch((error)=>{

        }); 
    }


    function exporttoexcel({id}){
        dataExporthelper.exportFromhtml({id:id,reportname:'Targatedhr_template'}); 
    }


    function downloadtemplate(){
       window.location.href = `${domainUrl}/api/downloadfile`;
    }

    function get_total_target_hours(){
        // console.log("sdsdsd");
        timesheetreportService.get_total_target_hours().then((response)=>{
             if(response.status == 200){
                let data = response.data.data;
                dataExporthelper.exportToExcel(data,{filename:'targethrstemplate'});  
             }else{
                  
             }
        }).catch((error)=>{

        });  
    }

    function selectexcelfile(event){
        const file = event.target.files[0];
        const reader = new FileReader();
        let base64String = '';
        reader.onload = function(event) {
            // Convert the file to Base64 string
            base64String = event.target.result;
            base64String = base64String.split("base64,")[1];
            let json_data = {
                "file_data":base64String
            };
            console.log('Base64 string:', base64String);
            setexcelFile(json_data);
            
        };
        reader.readAsDataURL(file);
    }

    function importexcelfile(){
        if(fileselected == ''){
            toast.current.show({ severity: 'error', summary: 'Target hours', detail: 'Select file first', life: 3000 });   
            return;
        }
        timesheetreportService.import_excelfile({file:fileselected}).then((response)=>{
            // console.log(response);
            if(response.status == 200){
                setexcelFile('');
                toast.current.show({ severity: 'success', summary: 'Target hours', detail: 'Updated successfully', life: 3000 }); 
            }else{
                toast.current.show({ severity: 'error', summary: 'Target hours', detail: 'Not updated', life: 3000 });   
            } 
        }).catch((error)=>{
            // console.log(error);
            toast.current.show({ severity: 'error', summary: 'Target hours', detail: 'Not updated', life: 3000 });   
        });
    }


    function handlechangeddata(e){
        const { name, value } = e.target;
        setadjustmentvalues((prevData) => ({
        ...prevData,
        [name]: value,
        }));

        console.log(name);
        
        // if(name == 'client'){
        //     _getsubclient({clientid:value}); 
        // } 
   }

   function handleSubmitform2(e){
    e.preventDefault();
    // console.log("adjustment values");
    // console.log(adjustmentvalues);
    let obj = {'data' : adjustmentvalues};
    timesheetService.editmultitargethours(obj).then((response)=>{
        if(response.status == 200){
            console.log('edit multi ');
            toast.current.show({ severity: 'success', summary: 'Multi Target hours', detail: 'Updated successfully', life: 3000 });    
            getmultitargethours();
            setVisibility(false);
        }else{
            console.log('edit multi '); 
            toast.current.show({ severity: 'error', summary: 'Multi Target hours', detail: 'Not Updated', life: 3000 });    
            setVisibility(false);
        }
    }).catch((error)=>{
        toast.current.show({ severity: 'error', summary: 'Multi Target hours', detail: 'error', life: 3000 });    
        setVisibility(false);
    }); 
    // updateadjustment(adjustmentvalues);
  }

  function saveadjustment(){
     let tempobj = adjustmentvalues;
     tempobj['adjustmentvalue'] = formData.adjustmentvalue;
     tempobj['adjustmentdate'] = formData.adjustmentdate;
     tempobj['adjustmentid'] = tempobj.adjustmentid;
     
     

     let date_ = formData.adjustmentdate;
     let date = date_.getFullYear() + '-'+ String(date_.getMonth() + 1).padStart(2, '0') + '-' + String(date_.getDate()).padStart(2, '0'); 
     tempobj['adjustmentdate'] = date;
     
     timesheetService.updateadjustment(tempobj).then((response)=>{
         if(response.status == 200){
            toast.current.show({ severity: 'success', summary: 'Target hours Adjustment', detail: 'Updated successfully', life: 3000 }); 
            // getmultitargethours();
            // setVisibility(false);
            let obj_ ={
                "userid":selecteduser,
                // 'id':tempobj.adjustmentid
            };
            // console.log("adjustment id");
            // console.log(tempobj.adjustmentid);
            gettargetadjustment(obj_);
         }else{

            console.log("response dsta");
            console.log(response.data.data);
            toast.current.show({ severity: 'error', summary: 'Target hours Adjustment', detail: `${response.data.data}`, life: 3000 });
         }
     }).catch((error)=>{
        toast.current.show({ severity: 'error', summary: 'Target hours Adjustment', detail: 'Error', life: 3000 });
     });
  }

  function getmultitargethoursadjustment(){
    console.log('getmultitargethoursadjustment');
     timesheetService.getmultitargethoursadjustment().then((response)=>{
        console.log("response data 1234567"); 
        console.log(response.data.data);
     })
     .catch((error)=>{
        console.log("error data");
        console.log(error);
     });
  }

  

 function _getclientslist(){
    let managerid = 1;
    let emparr = [];
    timesheetreportService.getclientslist({managerid:managerid}).then((response)=>{
        // console.log(response);
        response.data.data.forEach((value,index) =>{
            if(value.client != '' && value.client != 'all'){
                emparr.push((<option value={value.id}>{value.client}</option>));     
            }
        });
        setClientscomp(emparr);
     }).catch((error)=>{

     });    
 }

  const  Usertargethours = () => {
    return(
      <form onSubmit={(e) => handleSubmit2(e)}>
      <div className='row'>
          
      <div className="col-md-12"></div>  
      <br/><br/><br/> 
      <div className="col-md-2">
              <label className='pull-left'>Select Member <span className='error'>*</span></label>
              <select className='form-control' name="user_id2" value={formData2.user_id2} onChange={handleChange2}>
                  <option value=''>Select Member</option>
                  {/* <option value='ALL'>ALL</option> */}
                  {empcomp}
              </select>
  
              {errors.user_id2 && <span className='error'>{errors.user_id2}</span>}
          </div>
          <div className="col-md-3">
              <label className='pull-left'>Target Hours per/day<span className='error'>*</span></label>
              {/* <select className='form-control' name="manager" value={formData.manager} onChange={handleChange}>
                  <option value='ALL'>ALL</option>
                  {managerscomp}
              </select> */}
              <input type='text' name="target_hours2" className='form-control' onChange={handleChange2}/>
              {errors.target_hours2 && <span className='error'>{errors.target_hours2}</span>}
          </div> 
          
          <div className="col-md-3">
              <label className='pull-left'>From date <span className='error'>*</span></label>
              <br/>
              <Calendar  value={formData2.fromdate2} name="fromdate2" onChange={handleChange2} className='calender-custom-style custom-width-style' />
              {errors.fromdate2 && <span className='error'>{errors.fromdate2}</span>}
          </div>
  
          <div className="col-md-3">
              <label className='pull-left'>To date <span className='error'>*</span></label>
              <br/>
              <Calendar value={formData2.todate2} name="todate2" onChange={handleChange2} className='calender-custom-style custom-width-style' />
              {errors.todate2 && <span className='error'>{errors.todate2}</span>}
          </div>
      
  
          <div className="col-md-1">
              <div className='button-wrapper-style'>
                  <Button type='submit' stype="button" label="Save" severity="success" rounded className='custom-btn-style' />
              </div>
           </div>
      </div>
      </form>
  );
  }

  const Clienttargethours = () => {
    return(
      <form onSubmit={(e) => handleSubmit3(e)}>
      <div className='row'>
          
      <div className="col-md-12"></div>  
      <br/><br/><br/> 
      <div className="col-md-2">
              <label className='pull-left'>Select Client <span className='error'>*</span></label>
              <select className='form-control' name="client_id" required value={formData3.client_id} onChange={handleChange3}>
                  <option value=''>Select Client</option>
                  {cleintscomp}
              </select>
  
              {/* {errors.user_id2 && <span className='error'>{errors.user_id2}</span>} */}
          </div>
          <div className="col-md-2">
              <label className='pull-left'>Target Hours <span className='error'>*</span></label>
              {/* <select className='form-control' name="manager" value={formData.manager} onChange={handleChange}>
                  <option value='ALL'>ALL</option>
                  {managerscomp}
              </select> */}
              <input type='text' name="target_hours" value={formData3.target_hours} className='form-control' required onChange={handleChange3}/>
              {/* {errors.target_hours2 && <span className='error'>{errors.target_hours2}</span>} */}
          </div> 
          
          <div className="col-md-3">
              <label className='pull-left'>From date <span className='error'>*</span></label>
              <br/>
              <Calendar  value={formData3.fromdate} name="fromdate" onChange={handleChange3} className='calender-custom-style custom-width-style' />
              {/* {errors.fromdate2 && <span className='error'>{errors.fromdate2}</span>} */}
          </div>
  
          <div className="col-md-3">
              <label className='pull-left'>To date <span className='error'>*</span></label>
              <br/>
              <Calendar value={formData3.todate} name="todate" onChange={handleChange3} required className='calender-custom-style custom-width-style' />
              {/* {errors.todate2 && <span className='error'>{errors.todate2}</span>} */}
          </div>

          <div className="col-md-2">
              <label className='pull-left'>Type <span className='error'>*</span></label>
              <br/>
              <select name="type" className='form-control' onChange={handleChange3} required>
                  <option value="">Select</option>
                  <option value="fixed">Fixed</option>
                  <option value="variable">Variable</option>
              </select>
              {/* {errors.todate2 && <span className='error'>{errors.todate2}</span>} */}
          </div>
          
          <div className="col-md-1">
           
         
              <div className='button-wrapper-style'>
                  <Button type='submit' stype="button" label="Save" severity="success" rounded className='custom-btn-style mt-3' />
              </div>
           </div>
      </div>
      </form>
  );
  }

  const [date, setDate] = useState(null);

    // Function to check if a date is a Monday
    const isMonday = (date) => {
        return date.getDay() === 1; // 1 corresponds to Monday
    };

    // Function to generate an array of dates that should be disabled
    const getDisabledDates = () => {
        const disabledDates = [];
        const today = new Date();
        const firstDayOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);
        today.setHours(0, 0, 0, 0);

        for (let i = 1; i < 180; i++) {
            const pastDate = new Date(today);
            pastDate.setDate(pastDate.getDate() - i);
            if (!isMonday(pastDate)) {
                  disabledDates.push(pastDate);
            }
            // disabledDates.push(pastDate);
        }
        
        // Generate disabled dates for the next 30 days
        let nondisabledates = [];
        for (let i = 0; i < 180; i++) {
            const newDate = new Date(today);
            newDate.setDate(today.getDate() + i);
            if (!isMonday(newDate)) {
                if(getmonth(newDate) == getcurrentmonth()){
                    let lastday = getLastWeekdayOfMonth(newDate.getFullYear(),2);
                    if(lastday == newDate.getDate()){
                        // dont add        
                    }else{
                        disabledDates.push(newDate);    
                    }
                }else{
                    // for(var a = 1;a<=3;a++){
                    // let a = 1;
                        let objdata = getNextWeekday();
                        // console.log(objdata);
                        objdata.forEach((value)=>{
                        //    console.log(value);  
                            let {year,month,date} = value;
                            
                            if(((newDate.getMonth() + 1) == month) && ((newDate.getDate()) == date)){
                                //    console.log(newDate,'nondisable date');
                                   nondisabledates.push(newDate);
                            }else{
                               disabledDates.push(newDate);          
                            }
                        })
                }
            }
        }
        return removeDisabledDates(nondisabledates,disabledDates);
        return disabledDates;
    };
    const disabledDates = getDisabledDates(); 


    function removeDisabledDates(nondisabled, disabled) {
        let removedval = [];
        nondisabled.forEach((nonvalue)=>{
            disabled.forEach((enablevalue)=>{
                 if((enablevalue.getDate() != nonvalue.getDate()) && (enablevalue.getMonth() != nonvalue.getMonth())){
                       removedval.push(enablevalue); 
                 }
            })
        });
        return removedval;
    }

    function getcurrentmonth($date){
        let currentMonth = new Date().getMonth();
        return currentMonth + 1;
    }

    function getmonth($date){
         if($date != ''){
            return $date.getMonth() + 1; 
         }
    }

    function getLastWeekdayOfMonth(year, month) {
        // Get the last day of the month (month is 0-indexed in JavaScript Date)
        let lastDay = new Date(year, month + 1, 0);
        // Check if the last day is a Saturday (6) or Sunday (0)
        if (lastDay.getDay() === 6) { // Saturday
            lastDay.setDate(lastDay.getDate() - 1); // Move to Friday
        } else if (lastDay.getDay() === 0) { // Sunday
            lastDay.setDate(lastDay.getDate() - 2); // Move to Friday
        }
        return lastDay.getDate();
    }


    function getNextWeekday() {
        // console.log(monthcount);
        let obj = [];
        for(let a = 1;a<=2;a++){
            let monthcount = a;
            const today = new Date(); // Get today's date
            today.setDate(1);
            today.setMonth(today.getMonth() + monthcount);  
            // Check if today is Saturday or Sunday, and adjust the date
            if (today.getDay() === 6) { // Saturday
              today.setDate(today.getDate() + 2); // Skip to Monday
            } else if (today.getDay() === 0) { // Sunday
              today.setDate(today.getDate() + 1); // Skip to Monday
            }
            obj.push({
                "month" : today.getMonth() + 1,
                "date" : today.getDate(),
                "year" : today.getFullYear()
             });
            
           
        }

        // console.log(obj);
        
        return obj;
    }
      
    //   let date = new Date('2025-04-05');
    //   const nextWeekday = getNextWeekday(date);


    function setadjustmentdatavaluetarget(e){
        setadjustmentdatanewvalue((prevData)=>({
           ...prevData,
           [e.target.name]:e.target.value
        }));
    }

    function handleClientSubmitformadjustment(e){
         e.preventDefault();
        //  console.log("adjustment vaue");
        //  console.log(adjustmentdatanewvalue);
         updateadjustmentvalue();
    }

    function updateadjustmentvalue(){
         let obj = {
             'obj' :adjustmentdatanewvalue
         };
         timesheetService.updateadjustmentvalue(obj).then((response)=>{
              if(response.status == 200){
                toast.current.show({ severity: 'success', summary: 'Target hours Adjustment', detail: `${response.data.data}`, life: 3000 });
                setpopupvisibleadjustment(false);
                let obj_ ={
                    "userid":selecteduser
                };
                gettargetadjustment(obj_);
              }else{
                toast.current.show({ severity: 'error', summary: 'Target hours Adjustment', detail: `${response.data.data}`, life: 3000 }); 
                // setpopupvisibleadjustment(false);
              }      
         }).catch(()=>{
            toast.current.show({ severity: 'error', summary: 'Target hours Adjustment', detail: `Error`, life: 3000 });
            
        });
    }


    function delete_target_adjustment_tbl(id){
       let dataobj = {
          'id':id
       };  
       timesheetService.delete_target_adjustment_tbl(dataobj).then((response)=>{
          if(response.status == 200){
            toast.current.show({ severity: 'success', summary: 'Adjustment hours', detail: 'Deleted successfully', life: 3000 });    
            let temdata = {
                "userid":selecteduser
            };
            gettargetadjustment(temdata);
          }else{
            toast.current.show({ severity: 'error', summary: 'Adjustment hours', detail: 'Not Deleted', life: 3000 });     
          }  
       }).catch((error)=>{
          toast.current.show({ severity: 'error', summary: 'Adjustment hours', detail: 'Error', life: 3000 });    
          console.log(error);
       });    
    }

    function qaallocationdisplay(){
       
         timesheetService.getclientallocationpercentage().then((response)=>{
          
             if(response.status == 200){
               
                // console.log("response qaallocationdisplay");
                // console.log(response.data.data);
                setclientallocation(response.data.data);
                setclientallocationTemp(response.data.data);
                // setclientallocation();
             }
         }).catch((error)=>{
             console.log(error); 
         }) 
    }

    function onchangepercentage(event,index){
        let percentage = event.target.value;
        setclientallocationindex(index);    
        setclientallocation((prevData) => {
            const updatedClientAllocation = [...prevData];

            // Ensure the object at the given index exists
            if (updatedClientAllocation[index]) {
                // Update the percentage field while preserving other fields
                updatedClientAllocation[index] = {
                    ...updatedClientAllocation[index],
                    percentage: percentage, // Update percentage value
                };
            }
        
            // Return the updated array as the new state
            return updatedClientAllocation;
        });     
    }

    function savepercentage(){
        //  console.log("client allocation");   
        //  console.log(clientallocation);
         let clientdata = clientallocation[clientallocationindex];
         let dataobj = {
            'data':clientdata
         }

         timesheetService.updateclientallocationpercentage(dataobj).then((response)=>{
             console.log("response data");
             console.log(response); 
             if(response.status == 200){
                toast.current.show({ severity: 'success', summary: 'QA Allocation', detail: `Updated successfully`, life: 3000 }); 
                qaallocationdisplay();    
                displayallocation();
             }else{
                toast.current.show({ severity: 'error', summary: 'QA Allocation', detail: `Not updated`, life: 3000 });  
             }
         }).catch((error)=>{
            toast.current.show({ severity: 'error', summary: 'QA Allocation', detail: `Error`, life: 3000 });  
         })

    }

    function deletepercentage(id){
        setqaloaded(false);
         timesheetService.deletepercentage(id).then((response)=>{
            if(response.status == 200){
                toast.current.show({ severity: 'success', summary: 'QA Allocation', detail: `Deleted successfully`, life: 3000 });   
                qaallocationdisplay();  
                displayallocation(); 
                setqaloaded(true); 
            }else{
                toast.current.show({ severity: 'error', summary: 'QA Allocation', detail: `Not deleted`, life: 3000 });
            }
         }).catch((error)=>{
            toast.current.show({ severity: 'error', summary: 'QA Allocation', detail: `Error`, life: 3000 });
         });
    } 


    const displayallocation = () => {
          let emparray = [];
          clientallocation.forEach((value,index)=>{
            emparray.push(<tr>
                  <td>{index + 1}</td>
                  <td>{value.client}</td>
                 
                  <td><div style={{display:'flex'}}><input type='text' className='form-control' value={value.percentage} onChange={(event) => onchangepercentage(event,index)}/><button className='btn btn-success' onClick={()=> savepercentage()}>save</button></div></td>
                  
                  <td>
                    <button className='btn btn-danger' onClick={()=>deletepercentage(value.qid)}><FaTrash/></button>
                    </td>
            </tr>); 
          })

         return emparray; 
    } 

    function searchqaclient(e,type=''){
            let value = e.target.value; 
         
            if(type == ''){
               
                let _clientlist = clientallocationtemp;
                const searchRegexClient    = new RegExp(value.toLowerCase());
                const searchRegexSubclient = new RegExp(value.toLowerCase());
                //  console.log(value);
                // console.log('this section');
                // return; 
                const foundItems = _clientlist.filter(item => 
                //   (searchRegexClient.test(item.client) && searchRegexSubclient.test(item.subclient))
                (searchRegexClient.test(item?.client?.toLowerCase()) || searchRegexSubclient.test(item?.client?.toLowerCase()) || searchRegexSubclient.test(item?.from_date?.toLowerCase()) || searchRegexSubclient.test(item?.to_date?.toLowerCase())
                  || searchRegexSubclient.test(item?.name?.toLowerCase())      
                )
                );
    
                if (foundItems.length > 0) {
                    setclientallocation(foundItems);
                } else {
                    setclientallocation(clientallocationtemp);
                }      
            }else if(type=='clienttarget'){

                let _clientlist = clienttargettemp;
                const searchRegexClient    = new RegExp(value.toLowerCase());
                const searchRegexSubclient = new RegExp(value.toLowerCase());
                const foundItems = _clientlist.filter(item => 
                //   (searchRegexClient.test(item.client) && searchRegexSubclient.test(item.subclient))
                (searchRegexClient.test(item?.client?.toLowerCase()) || searchRegexSubclient.test(item?.client?.toLowerCase())
              )
                );
    
                if (foundItems.length > 0) {
                    console.log('items found.');
                    setClienttarget(foundItems);
                } else {
                    console.log('No items found.');
                    // setDatacomp([]);
                    setClienttarget(clienttargettemp);
                }  

            }else if(type=='usertarget'){
              
                let _clientlist = usertargethousrsdatatemp;
                const searchRegexClient    = new RegExp(value.toLowerCase());
                const searchRegexSubclient = new RegExp(value.toLowerCase());
                const foundItems = _clientlist.filter(item => 
                //   (searchRegexClient.test(item.client) && searchRegexSubclient.test(item.subclient))
                (searchRegexClient.test(item?.name?.toLowerCase()) || searchRegexSubclient.test(item?.name?.toLowerCase()) || searchRegexSubclient.test(item?.from_date?.toLowerCase()) || searchRegexSubclient.test(item?.to_date?.toLowerCase()))
                );
    
                if (foundItems.length > 0) {
                    // console.log('items found.');
                    settargethoursdata(foundItems);
                } else {
                    // console.log('No items found.');
                    // setDatacomp([]);
                    settargethoursdata(usertargethousrsdatatemp);
                }   
            }
            
    }

    function powerbiupdate(e){
         e.preventDefault();
         let date = e.target.particulardate.value; 
         setUpdation(false);
         timesheetService.powerbiupdate(date).then((response)=>{
               if(response.status == 200){
                  toast.current.show({ severity: 'success', summary: 'Powerbi', detail: `Uploaded`, life: 3000 }); 
                  setUpdation(true);
               }else{
                   toast.current.show({ severity: 'error', summary: 'Powerbi', detail: `Not uploaded`, life: 3000 });  
                   setUpdation(true);      
               } 
         }).catch((error)=>{
            toast.current.show({ severity: 'error', summary: 'Powerbi', detail: `Error`, life: 3000 }); 
            setUpdation(true);
         })  
    }


   function powerbiupdatenew(datenew) {
    let date = datenew;
    setUpdation(false);

    return timesheetService.powerbiupdate(date) // ✅ return this
        .then((response) => {
            if (response.status === 200) {
                toast.current.show({ severity: 'success', summary: 'Powerbi', detail: `Uploaded`, life: 3000 });
            } else {
                toast.current.show({ severity: 'error', summary: 'Powerbi', detail: `Not uploaded`, life: 3000 });
            }
            setUpdation(true);
        })
        .catch((error) => {
            toast.current.show({ severity: 'error', summary: 'Powerbi', detail: `Error`, life: 3000 });
            setUpdation(true);
            setcronstatus(false);
        });
   }



    useEffect(() => {
            if (!cronstatus) return;

            let data = crondaterange.firstDate.getDate() - 1;
            let target = crondaterange.lastDate.getDate();

            let month = (crondaterange.firstDate.getMonth() + 1).toString().padStart(2, '0');
            let year = crondaterange.firstDate.getFullYear();

            let stop = false;

            const run = async () => {
                if (stop || data >= target) return;

                data += 1;
                let padded = data.toString().padStart(2, '0');
                let newdate = `${year}-${month}-${padded}`;

                console.log("Sending date:", newdate);
                try {
                await powerbiupdatenew(newdate); // Wait for the API call to complete
                console.log("Power BI update done for", newdate);
                } catch (err) {
                console.error("Error updating Power BI:", err);
                }

                if (data < target) {
                setTimeout(run, 1000); // Wait 5 seconds before next call
                } else {
                setcronstatus(false);
                console.log("Finished all updates.");
                }
            };

            run(); // start the recursive calls

            return () => {
                stop = true; // if the component unmounts or dependencies change
            };
            }, [cronstatus, crondaterange]);

    // useEffect(()=>{
    //      if (!cronstatus) return;
    //     let data = crondaterange.firstDate.getDate() - 1;
    //     let target = crondaterange.lastDate.getDate();
    //     let interval = setInterval(()=>{
    //       if(target != data){
    //            data = data + 1;  
    //            // console.log(data); 
    //           let padded = data.toString().padStart(2, '0');
             
    //           let month = crondaterange.firstDate.getMonth() + 1;
    //           let year  = crondaterange.firstDate.getFullYear();
    //           month = month.toString().padStart(2, '0');
    //           let newdate = year+'-'+month+'-'+padded; 

    //         //   console.log(newdate);
    //           powerbiupdatenew(newdate);
    //            // call the api for update     
    //       }else{
    //         clearInterval(interval);
    //         //  setcronstatus(true);
    //       }
          
    //       console.log("Target hours template");
    //    },5000);  

    //    return () => clearInterval(interval);
    // },[cronstatus,crondaterange])


    function getFirstAndLastDate(year, month) {
        month = month - 1;
        const firstDate = new Date(year, month, 1);
        const lastDate = new Date(year, month + 1, 0);
        return {
            firstDate: firstDate, // format: YYYY-MM-DD
            lastDate: lastDate,
        };
    }


    const updatenewcronstatus = (e) =>{
         e.preventDefault();
         console.log("update cron status");
         let splitteddata = e.target.monthselected.value.split('-');
       
         if(splitteddata.length > 0){
            // console.log(getFirstAndLastDate(splitteddata[0],splitteddata[1]));
            setcrondaterange(getFirstAndLastDate(splitteddata[0],splitteddata[1]));
            setcronstatus(true);      
         }
    }


    const updateclienttargetuploadtopoweri = (e) =>{
          setisclientupdated(false); 
          e.preventDefault();
          timesheetService.updateclienttargetuploadtopoweri({month:'',year:''}).then((response)=>{
            if(response.status == 200){
                toast.current.show({ severity: 'success', summary: 'Powerbi', detail: `Success`, life: 3000 });         
                setisclientupdated(true);
            }else{
                toast.current.show({ severity: 'error', summary: 'Powerbi', detail: `Error`, life: 3000 }); 
                setisclientupdated(true);
            }
          }).catch((error)=>{
              toast.current.show({ severity: 'error', summary: 'Powerbi', detail: `Error`, life: 3000 }); 
              setisclientupdated(false);
          })
    }

    return (
        <>
            <Toast ref={toast} />
            <div className="invisible-divider-sm"></div>
              <Dialog header="Edit Target" position='top' visible={popupvisible} style={{ width: '60vw' }} onHide={() => setVisibility(false)}>
               <form onSubmit={(e) => handleSubmitform2(e)}>
               <div className='col-md-12'>
                  <div className='row'>
                      <div className='col-md-12'>
                      </div>
                  </div>
                 <div className='row'>
                     <div className='col-md-3'>
                        <label><Mandate/>User</label>
                        <input type="text" className='form-control' disabled={true} value={adjustmentvalues.name}/>    
                     </div>
                     <div className='col-md-3'>
                        <label><Mandate/>Target hours per/day</label><span></span> 
                        <input type="text" className='form-control' name="targethours" value={adjustmentvalues.targethours} onChange={(e) => handlechangeddata(e)}/>
                     </div>

                     <div className='col-md-3'>
                        <br/>
                        <Button type="submit" className='custom-btn-style p-button p-component p-button-rounded p-button-success'  style={{height: '38px'}} label="Save" severity="success" rounded />
                     </div>

                 </div> 
                 <br/>
                     <br/>

                  <div className='row'>
                     <br/>
                     <h4 style={{color:'skyblue'}}>Target hour Adjustment :</h4>
                     <div className='col-md-3'>
                        <label><Mandate/>Target Adjustment</label>
                        <input type="text" value={formData.adjustmentvalue} name="adjustmentvalue" onChange={handleChange} className='form-control'/>    
                     </div>

                     <div className='col-md-3'>
                       <label><Mandate/>Adjustment Date</label>
                       <Calendar value={formData.adjustmentdate} disabledDates={disabledDates} name="adjustmentdate" onChange={handleChange} className='calender-custom-style custom-width-style' />
                     </div>

                     <div className='col-md-3'>
                        <br/>
                        <Button type="button"  className='custom-btn-style p-button p-component p-button-rounded p-button-success' style={{height: '38px'}} label="Save" severity="success" rounded onClick={saveadjustment}/>
                     </div>

                  </div> 
                  <br/> 

                  <div className='row'>
                     <div className='col-md-12'>
                       {displayadjustmentversion2()}
                     </div>
                  </div> 
                  

                  <div className='row'>
                    <div> 
                      <div className='pull-right'>
                          <span>
                            <Button type="button" onClick={() => setVisibility(false)} stype="button" label="Close" severity="danger" rounded /> 
                          </span>
                      </div>
                    </div>
                  </div>    
               </div>
              </form>
             </Dialog>


             {/* edit client target hours */}
             <Dialog header="Edit Client Target" position='top' visible={popupvisibleClient} style={{ width: '60vw' }} onHide={() => setVisibilityClient(false)}>
               <form onSubmit={(e) => handleClientSubmitform(e)}>
               <div className='col-md-12'>
                  <div className='row'>
                      <div className='col-md-12'>
                      </div>
                  </div>
                 <div className='row'>
                     <div className='col-md-3'>
                        <label><Mandate/>Client</label>
                        <input type="text" className='form-control' disabled={true} value={adjustmentclientvalues.client} onChange={(e) => handleclientchangeddata(e)}/>    
                     </div>

                     <div className='col-md-3'>
                        <label><Mandate/>From date</label>
                        <input type="date" className='form-control' name="from_date"  value={adjustmentclientvalues.from_date} onChange={(e) => handleclientchangeddata(e)}/>    
                     </div>

                     <div className='col-md-3'>
                        <label><Mandate/>To date</label>
                        <input type="date" className='form-control' name="to_date"  value={adjustmentclientvalues.to_date} onChange={(e) => handleclientchangeddata(e)}/>    
                     </div>

                     <div className='col-md-3'>
                        <label><Mandate/>Target hours</label><span></span> 
                        <input type="text" className='form-control' name="targethours" value={adjustmentclientvalues.targethours} onChange={(e) => handleclientchangeddata(e)}/>
                     </div>

                     <div className='col-md-3'>
                        <label><Mandate/>Type</label><span></span> 
                        <select name="type" value={adjustmentclientvalues.type} onChange={(e) => handleclientchangeddata(e)} className='form-control' required>
                            <option value="">select</option>
                            <option value="fixed">Fixed</option>
                            <option value="variable">Variable</option>    
                        </select>  
                     </div>

                     <div className='col-md-3'>
                        <br/>
                        <Button type="submit" className='custom-btn-style p-button p-component p-button-rounded p-button-success'  style={{height: '38px'}} label="Save" severity="success" rounded />
                     </div>

                 </div> 
                 <br/>
                     <br/>
                  

                  <div className='row'>
                    <div> 
                      <div className='pull-right'>
                          <span>
                            <Button type="button" onClick={() => setVisibilityClient(false)} stype="button" label="Close" severity="danger" rounded /> 
                          </span>
                      </div>
                    </div>
                  </div>    
               </div>
              </form>
             </Dialog>


             {/* edit client target hours */}
             <Dialog header="Edit Adjustment" position='top' visible={popupvisibleadjustment} style={{ width: '60vw' }} onHide={() => setpopupvisibleadjustment(false)}>
               <form onSubmit={(e) => handleClientSubmitformadjustment(e)}>
               <div className='col-md-12'>
                  <div className='row'>
                      <div className='col-md-12'>
                      </div>
                  </div>
                 <div className='row'>
                     <div className='col-md-3'>
                        <label><Mandate/>Adjustment Value</label><span></span> 
                        <input type="text" className='form-control' name="adjustmentval" value={adjustmentdatanewvalue.adjustmentval} onChange={(e) => setadjustmentdatavaluetarget(e)}/>
                     </div>

                     <div className='col-md-3'>
                        <br/>
                        <Button type="submit" className='custom-btn-style p-button p-component p-button-rounded p-button-success'  style={{height: '38px'}} label="Save" severity="success" rounded />
                     </div>

                 </div> 
                 <br/>
                     <br/>
                  

                  <div className='row'>
                    <div> 
                      <div className='pull-right'>
                          <span>
                            <Button type="button" onClick={() => setpopupvisibleadjustment(false)} stype="button" label="Close" severity="danger" rounded /> 
                          </span>
                      </div>
                    </div>
                  </div>    
               </div>
              </form>
             </Dialog>

            <div className="invisible-divider-sm"></div>
            <div className='card card-custom-style card-style-padding'>
                
                {/* <br></br> */}
                {/* <div className='row'>
                     <div className='col-md-12'>
                        <h3 className='pull-left'>
                          Add multi target hours :
                        </h3>
                     </div>
                </div> */}
                <div className='row' style={{paddingTop:'18px'}}>
                         <div className='col-md-12' style={{borderRight: '1px solid #d5d5d5'}}>
                            <Tabs>
                                <TabList>
                                <Tab> <span style={{textTransform: 'capitalize'}}>Single User Target Hours</span></Tab>
                                <Tab>User Target Hours</Tab>
                                <Tab>Client Target Hours</Tab>
                                <Tab>QA Allocation Hours</Tab>
                                </TabList>
                                    
                                <TabPanel>
                                 <br></br>    
                                <div className='row'>
                                    <div className='col-md-8'>
                                        <div  className='row'> 
                                            <div className='col-md-7'>
                                                <div className='row'>
                                                    <div className='col-md-12'>
                                                    <p className='text-left'>Please click on Download button to download a Template !</p>
                                                    </div>
                                                    <div className='button-wrapper-style'>
                                                        <div className='col-md-6'>
                                                            <Button type='button' stype="button" onClick={() => exporttoexcel({id:'userdetails-table'})} label="Download Template" severity="success" rounded className='custom-btn-style pull-left' />
                                                        </div>
                                                        <div className='col-md-6'>
                                                            <Button type='button' stype="button" onClick={() => downloadtemplate()} label="Reference Template" severity="danger" rounded className='custom-btn-style' />
                                                        </div>
                                                    </div> 
                                                    
                                                    <p></p>
                                                    <p className='text-left'><b>Note:</b></p>
                                                    <p className='text-left custom-style custom-style-size'><b> 1) Download Template button, is a Template with User id and Email and used for Upload.</b></p> 
                                                    <p className='text-left custom-style custom-style-size'><b> 2) Reference Template button, is used as a Reference for Creating a Uploading Target Template</b></p>
                                                    <p className='text-left custom-style custom-style-size'><b> 2) Employee Target Hours is a list of Target hours of an employee.</b></p>
                                                    <div className='col-md-12'>
                                                    <div className='button-wrapper-style'>
                                                        <Button type='button' stype="button" onClick={() => get_total_target_hours()} label="Employee Target Hours" severity="info" rounded className='custom-btn-style pull-left' />
                                                    </div>
                                                </div>
                                                </div>
                                            </div>
                                            
                                            <div className='col-md-4'>
                                                <p className='text-left'>Upload Template here:</p>
                                                <div className='card card-style-padding-sm'>
                                                <input type="file" onChange={(e) => selectexcelfile(e)}/>
                                                <br/>
                                                <div className='button-wrapper-style'>
                                                <Button type='button' onClick={()=>importexcelfile()} stype="button" label="Submit" severity="success" rounded className='custom-btn-style' />
                                                </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='col-md-4'>
                                    <form onSubmit={handleSubmit}>
                                        <div className='row'>
                                        <div className="col-md-12"><h3 className='pull-left'>
                                            Add single target hours</h3></div>  
                                        <br/><br/><br/> 
                                        <div className="col-md-6">
                                                <label className='pull-left'>Select Member</label>
                                                <select className='form-control' name="user_id" value={formData.user_id} onChange={handleChange}>
                                                    <option value=''>Select Member</option>
                                                    <option value='ALL'>ALL</option>
                                                    {empcomp}
                                                </select>

                                                {errors.user_id && <span className='error'>{errors.user_id}</span>}
                                            </div>
                                            <div className="col-md-6">
                                                <label className='pull-left'>Target Hours</label>
                                                {/* <select className='form-control' name="manager" value={formData.manager} onChange={handleChange}>
                                                    <option value='ALL'>ALL</option>
                                                    {managerscomp}
                                                </select> */}
                                                <input type='number' name="target_hours" className='form-control' onChange={handleChange}/>
                                                {errors.target_hours && <span className='error'>{errors.target_hours}</span>}
                                            </div> 
                                            
                                            <div className="col-md-6">
                                                <br/>  
                                                <label className='pull-left'>Target date</label>
                                                <br/>
                                                <Calendar view='month' value={formData.targetdate} name="targetdate" onChange={handleChange} className='calender-custom-style custom-width-style' />
                                                {errors.targetdate && <span className='error'>{errors.targetdate}</span>}
                                            </div>
                                        

                                            <div className="col-md-6">
                                                <div className='button-wrapper-style'>
                                                    <Button type='submit' stype="button" label="Save" severity="success" rounded className='custom-btn-style' />
                                                    &nbsp;&nbsp;&nbsp; 
                                                </div>

                                            </div>
                                        </div>
                                        </form>
                                        
                                    </div>
                                </div>
                                    
                                </TabPanel>    

                                <TabPanel>
                                    {Usertargethours()}

                                    <br></br>
                                    <div className='col-md-2'>
                                       <input type="text" className='form-control' placeholder='Search Users' onKeyUp={(e) => searchqaclient(e,'usertarget')}/>
                                    </div>
                                    <br></br>

                                    <div className='row'>
                                        {/* <div className='col-md-6'>
                                        <form onSubmit={(e) => powerbiupdate(e)} style={{textAlign:'left'}}>
                                         <label className='error'>Manual upload the dataset to <br/> Power BI with date-based records</label> 
                                        
                                         <br></br> 
                                         <br></br> 
                                         <div className='container-box col-md-3'>
                                           <input type='date' required name="particulardate" className='form-control'/>         
                                           <button type='submit' className='btn btn-warning' title="Update to Powerbi"><span style={{color:'white'}}>Update {!isupdated ? loader.Smallloader() : <></>}</span></button>        
                                        </div>   
                                        </form>  
                                        </div> */}

                                        <div className='col-md-6'>
                                        <form onSubmit={(e) => updatenewcronstatus(e)} style={{textAlign:'left'}}>
                                         <label className='error'>Manual upload the dataset, Month Wise to <br/> Power BI with date-based records</label> 
                                         <br/>
                                         {cronstatus ? (<label>Please Don`t Refresh the Page Updation is in progress...</label>) : <></>}
                                         
                                         <br></br> 
                                         <br></br> 
                                         <div className='container-box col-md-3'>
                                           <input type='month' required name="monthselected" className='form-control'/>         
                                           <button type='submit' className='btn btn-warning' title="Update to Powerbi"><span style={{color:'white'}}>Update {!isupdated ? loader.Smallloader() : <></>}</span></button>        
                                        </div>   
                                        </form>  
                                        </div>      
                                    </div>
                                    <br></br>
                                  
                                   <div className="col-md-12">
                                        <br></br>
                                            {!istargethousrsloaded ? loader.Loadermd() : (<table id="userdetails-table"  className="table table-bordered">
                                                <thead>
                                                    <tr>
                                                        <th>Sr no</th>
                                                        <th>User</th>
                                                        <th>Target hours</th>
                                                        <th>From date</th>
                                                        <th>To date</th>
                                                        <th>Created at</th>
                                                        <th>Updated at</th>
                                                        {/* <th>Adjust Target</th>
                                                        <th>Adjust date</th> */}
                                                        <th>Action</th>
                                                    </tr>
                                                </thead> 
                                                <tbody>
                                                    {displaytargethours()}   
                                                </tbody>    
                                            </table>)}
                                            
                                        </div>
                                </TabPanel>
                                <TabPanel>
                                    <div className='col-md-12'>
                                        <form onSubmit={(e) => updateclienttargetuploadtopoweri(e)} style={{textAlign:'left'}}>
                                         <label className='error'>Manual upload the client target dataset to, <br/> Power BI with date-based records</label> 
                                         <br/>
                                         {/* {cronstatus ? (<label>Please Don`t Refresh the Page Updation is in progress...</label>) : <></>}    */}
                                         <br></br> 
                                         <div className='container-box col-md-4'>
                                           {/* <input type='month' required name="monthselected" className='form-control'/>          */}
                                           <button type='submit' className='btn btn-warning' title="Update to Powerbi"><span style={{color:'white'}}>Update {!isclientupdated ? loader.Smallloader() : <></>}</span></button>        
                                        </div>   
                                      </form>                           
                                    </div>
                                                           
                                    {Clienttargethours()}

                                    <br></br>
                                    <div className='col-md-2'>
                                       <input type="text" className='form-control' placeholder='Search Client' onKeyUp={(e) => searchqaclient(e,'clienttarget')}/>
                                    </div>
                                    <br></br>
                                   
                                    {displayclienttarget()}
                                </TabPanel>

                                <TabPanel>
                                    <br></br>
                                    <div className='col-md-2'>
                                       <input type="text" className='form-control' placeholder='Search Client' onKeyUp={(e) => searchqaclient(e)}/>
                                    </div>
                                    <br></br>
                                   
                                    {
                                      !isqaloaded ? loader.Loadermd() : (<table className='table table-bordered'> 
                                        <thead>
                                             <tr>
                                                 <td>SR no</td>
                                                 <td>Clients</td>
                                                 <td>Percentage</td>
                                                 <td>Action</td>
                                             </tr>
                                        </thead>
                                        <tbody>{displayallocation()}</tbody>
                                      
                                    </table>) 
                                    }
                                    
                                </TabPanel>
                            </Tabs>    
                        </div>
                        
                        
                 </div>
            </div>

            <div className="invisible-divider-sm"></div>
            {/* <div className="row">
                <h1>table</h1>
            </div> */}
        </>
    );
}

export default Targethourstemplates;